export { VehicleTypeSelection, type VehicleTypeSelectionProps } from './VehicleTypeSelection';
